import { render } from "./LanguagePicker.vue?vue&type=template&id=136a3477&ts=true&lang=html"
import script from "./LanguagePicker.vue?vue&type=script&lang=ts&setup=true"
export * from "./LanguagePicker.vue?vue&type=script&lang=ts&setup=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__